// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const QuickActionService = {
    CreateQuickAction(fn, req) {
        return fn(`/quick-actions/v1/quick-action`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetQuickActionsOfUser(fn, req) {
        return fn(`/quick-actions/v1/user-quick-action?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateQuickActionOfUser(fn, req) {
        return fn(`/quick-actions/v1/user-quick-action`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteQuickAction(fn, req) {
        try {
            fm.validateUrlParam(req["label"], "label");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/quick-actions/v1/quick-action/${req["label"]}?${fm.renderURLSearchParams(req, ["label"])}`, { method: "DELETE" });
    },
    DeleteUserPreferenceForQuickAction(fn, req) {
        return fn(`/quick-actions/v1/user-quick-action?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
};
